import React from "react";
import TablePaginationBar from "../TablePaginationBar";

const SessionPagination = ({
  appointmentsPerPage,
  setAppointmentsPerPage,
  setCurrentPage,
  currentPage,
  totalPages,
  totalSessions,
  indexOfFirstSession,
  indexOfLastSession,
  paginate,
}) => {
  return (
    <TablePaginationBar
      currentPage={currentPage}
      totalItems={totalSessions}
      rowsPerPage={appointmentsPerPage}
      onPageChange={paginate}
      onRowsPerPageChange={(n) => {
        setAppointmentsPerPage(n);
        setCurrentPage(1);
      }}
      rowsPerPageOptions={[20, 50, 100]}
      hideWhenEmpty={totalSessions === 0}
      style={{ paddingLeft: "20px", paddingRight: "20px" }}
    />
  );
};

export default SessionPagination;
